import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldOperatorDate extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'date');
  }
}
